import { wordIndexFromOffset } from './textHelper'

const timestampIsUnknown = timestamp => timestamp === -1

const findIndexOfKnownTimestamp = (wordIndex, timestamps, whenUnknown) => {
  if (timestampIsUnknown(timestamps[wordIndex])) {
    return findIndexOfKnownTimestamp(
      whenUnknown(wordIndex),
      timestamps,
      whenUnknown
    )
  }

  return wordIndex
}

const estimatedTimeAtIndex = (timestamps, wordIndex) => {
  const previousKnownWordIdx = findIndexOfKnownTimestamp(
    wordIndex,
    timestamps,
    idx => idx - 1
  )
  const previousKnownTimestamp = parseFloat(timestamps[previousKnownWordIdx])
  const nextKnownWordIdx = findIndexOfKnownTimestamp(
    wordIndex,
    timestamps,
    idx => idx + 1
  )
  const nextKnownTimestamp = parseFloat(timestamps[nextKnownWordIdx])

  const timeDifference = nextKnownTimestamp - previousKnownTimestamp
  const knownTimestampGap = nextKnownWordIdx - previousKnownWordIdx
  const gapIndex = wordIndex - previousKnownWordIdx

  return (
    (timeDifference / knownTimestampGap) * gapIndex + previousKnownTimestamp
  )
}

const sizeOfWord = word => word.replace(/\n+/, '').length

const offsetsOfWordIndex = (index, transcript) => {
  const words = transcript.trim().split(/\s+/)
  const whitespaces = transcript.split(/\S+/)
  const whitespacesUpToWord = whitespaces
    .slice(0, index + 1)
    .map(whitespaces => whitespaces.length)
    .reduce((a, b) => a + b)
  const endOffset =
    words.slice(0, index + 1).join('').length + whitespacesUpToWord - 1

  return {
    endOffset,
    startOffset: endOffset - (sizeOfWord(words[index]) - 1)
  }
}

const timeAtIndex = (timestamps, index) => {
  if (timestampIsUnknown(timestamps[index])) {
    return estimatedTimeAtIndex(timestamps, index)
  }

  return parseFloat(timestamps[index])
}

export const timeAtOffset = (offset, transcript, timestamps) =>
  timeAtIndex(timestamps, wordIndexFromOffset(offset, transcript))

const binarySearchTimestamp = (
  timestamps,
  time,
  lowerIndex = 0,
  upperIndex = Math.max(timestamps.length - 1, 0)
) => {
  const index = timestamps.indexOf(time)

  if (index !== -1) {
    return index
  }

  const midpoint = Math.floor((upperIndex + lowerIndex) / 2)
  const comparedTime = timeAtIndex(timestamps, midpoint)

  if (time === comparedTime) {
    return midpoint
  }

  if (upperIndex - lowerIndex <= 1) {
    if (time > timeAtIndex(timestamps, upperIndex)) {
      return upperIndex
    }

    return lowerIndex
  }

  if (time > comparedTime) {
    return binarySearchTimestamp(timestamps, time, midpoint, upperIndex)
  }

  return binarySearchTimestamp(timestamps, time, lowerIndex, midpoint)
}

export const offsetsAtTime = (time, transcript, timestamps) =>
  offsetsOfWordIndex(binarySearchTimestamp(timestamps, time), transcript)



// WEBPACK FOOTER //
// ../src/utils/timeOffsetHelper.js